import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DashboardLoader } from "../utils/Loading";
import { ServiceApi } from "../services/index.service";
import { setStorePermissions, storeSet } from "../redux/store/storeSlice";
import { Backdrop, CircularProgress } from "@mui/material";
import { GetLocalStore } from "../utils/storage";
//Tour imports
import { runTour, showTourProgress, updateSteps } from "../redux/userOnboarding/userOnboardingSlice";
import { DASHBOARD_TOUR_STEPS } from "../utils/tourConstants";
import { useOktaAuth } from "@okta/okta-react";

const options = [
  {
    name: "Flavor Portal", //"Today's Flavors",
    id: 1,
    link: "",
    comp: "flavors",
    text: "FlavorBoard",
  },
  {
    name: "Digital Recipe Portal",
    id: 2,
    link: "",
    comp: "recipes",
    text: "DigitalRecipePortal",
  },
  {
    name: "Flavor Admin", //"Manage Flavors",
    id: 3,
    link: "",
    comp: "manage-flavors",
    text: "FlavorAdmin",
  },
  {
    name: "Digital Menu Board",
    id: 4,
    link: "",
    comp: "board-administration",
    text: "DigitalMenuBoard",
  },
  {
    name: "Digital Drive Thru Board", // "Drive Thru",
    id: 8,
    link: "",
    comp: "drive-thru",
    text: "DigitalDriveThruBoard",
  },
  {
    name: "Flavor Driven Treat Admin", //"Manage Flavor Driven Treats",
    id: 9,
    link: "",
    comp: "flavor-driven-treats",
    text: "FlavorDrivenTreatAdmin",
  },
  {
    name: "Hours of Operation",
    id: 10,
    link: "",
    comp: "hours-of-operation",
    text: "HoursOfOperation",
  },
  {
    name: "Shop Website Customization", // "Website Customization",
    id: 11,
    link: "",
    comp: "shop-website-customization",
    text: "ShopWebsiteCustomization",
  },
  {
    name: "Cool Alerts",
    id: 13,
    link: "",
    comp: "cool-alerts",
    text: "CoolAlerts",
  },
  {
    name: "Online Order Portal",
    id: 14,
    link: process.env.REACT_APP_ONLINE_ORDER_OKTA_PORTAL_URL,
    comp: "",
    text: "OnlineOrderPortal",
  },
  {
    name: "Pre-Sell Board Admin",
    id: 15,
    link: "",
    comp: "pre-sell-board-admin",
    text: "PreSellBoardAdmin",
  },
  {
    name: "Production Sheet",
    id: 16,
    link: "",
    comp: "production",
    text: "ProductionSheet",
  },
  {
    name: "Buy Merchandise",
    id: 17,
    link: "",
    comp: "purchase-merchendise",
    text: "BuyMerchendize"
  },
  {
    name: "Pre-Sell Board Configuration",
    id: 18,
    link: "",
    comp: "pre-sell-board-conf",
    text: "DigitalDriveThruWithPreSellBoard"
  },
  // {
  //   name: "Online Ordering",
  //   id: 19,
  //   link: "https://loyalty.training.demotesturl.net/admin/system-settings",
  //   comp: "online-ordering",
  //   text: "OnlineOrdering"
  // },
  /* {
    name: "Loyalty Portal",
    id: 20,
    link: "https://loyalty.training.demotesturl.net/admin/system-settings",
    comp: "loyalty-portal",
    text: "LoyaltyPortal"
  } */
  {
    name: "Loyalty Portal",
    id: 20,
    link: process.env.REACT_APP_LOYALTY_PORTAL_URL,
    comp: "loyalty-portal",
    text: "LoyaltyPortal"
  },
  {
    name: "Vendor Portal",
    id: 21,
    link: "",
    comp: "vendor-portal",
    text: "OnlineVendorOrdering" // Role has to add
  },
  {
    name: "Sales Update",
    id: 23,
    link: "",
    comp: "sales-update",
    text: "SalesUpdate" // Role has to add
  },
  {
    name: "P&L Submission",
    id: 25,
    link: "",
    comp: "profit-loss",
    text: "ProfitLossTool",
  },
  {
    name: "RFC Library",
    id: 22,
    link: "",
    comp: "rfc-library",
    text: "rfclibrary" // Role has to add
  },
  // {
  //   name: "Edit Options",
  //   id: 22,
  //   link: "https://dmb.ritasice.com/",
  //   comp: "",
  //   text: "EditOptions",
  // },
  // Commenting catering-portal temporarily
  // {
  //   name: "Catering Portal",
  //   id: 23,
  //   link: "",
  //   comp: "catering-portal",
  //   text: "CateringPortal",
  // },
];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AdminDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const serviceapi = new ServiceApi();
  const { accessToken } = useSelector((state) => state?.token);
  const { profile, storage, userOnboarding } = useSelector((state) => state);
  const [store, setStore] = React.useState(null);
  const [storeList, setStoreList] = React.useState([]);
  const [query, setQuery] = React.useState("");
  const [permissions, setPermissions] = React.useState(null);
  const [storeLoading, setStoreLoading] = React.useState(false);
  const [permissionLoading, setPermissionLoading] = React.useState(false);
  const [oktaApps, setOktaApps] = React.useState([]);  // Okta assigned apps
  const { authState } = useOktaAuth();

  // React.useEffect(() => {
  //   if(GetLocalStore('token')){
  //     getFCUserStores("all");
  //   }
  // }, []);


  React.useEffect(() => {
    if (GetLocalStore('token') && store) {
      fetchStorePermissions();
    }
  }, [store]);

  //Start the tour after store and permissions succesfully loaded
  React.useEffect(() => {
    const dashboardTourStatus = userOnboarding?.tourStatus?.dashboard;
    if (!dashboardTourStatus) startDashboardTour();
  }, [permissions, userOnboarding.tourStatus?.dashboard])

  const startDashboardTour = () => {
    if (!storeLoading && !permissionLoading) {
      dispatch(updateSteps(DASHBOARD_TOUR_STEPS));
      dispatch(showTourProgress());
      dispatch(runTour("dashboard"));
    }
  }

  React.useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);

  // Fetch Okta apps assigned to this user (uses profile.sub = Okta user ID).
  // Store features under a per-user key so that a different user logging in
  // the same browser never reads a stale value. The resulting labels also
  // gate the P&L Submission tile (see canViewProfitLoss) and RFC Library tile.
  React.useEffect(() => {
    if (profile?.sub) {
      const featuresKey = `enabled_features_${profile.sub}`;
      serviceapi.getApps(profile.sub)
        .then((res) => {
          // API returns a plain array directly in res.data
          const apps = Array.isArray(res?.data) ? res.data : (res?.data?.body || []);
          const labels = apps.map(a => a.label?.toLowerCase());
          setOktaApps(labels); // used for card visibility: checks "rfc library" / "p&l submission"
          // enabled_features: based on "hand-scooped library" label (separate from card visibility)
          const hasHandScooped = labels.includes("hand-scooped library - dst");
          const enabledFeatures = hasHandScooped ? ["hand_scooped"] : [];
          localStorage.setItem(featuresKey, JSON.stringify(enabledFeatures));
        })
        .catch(() => {
          setOktaApps([]);
          localStorage.setItem(featuresKey, JSON.stringify([]));
        });
    }
  }, [profile?.sub]);

  const fetchStorePermissions = async () => {
    const req = {
      intStoreID: store?.intStoreID,
      role: profile?.role,
    };
    setPermissionLoading(true)
    const res = await serviceapi.fetchStorePermissions(req);
    setPermissionLoading(false)
    setPermissions(res);
    dispatch(setStorePermissions(res))
  };

  const openSite = (lnk) => {

    if (lnk.link !== "") {
      switch (lnk.text) {
        case "OnlineOrderPortal":
          if (authState?.idToken?.issuer === process.env.REACT_APP_OKTA_ISSUER) {
            window.open(process.env.REACT_APP_ONLINE_ORDER_OKTA_PORTAL_URL);
          } else {
            window.open(lnk.link);
          }
          break;
        case "EditOptions":
          const editOptionsUrl = `${process.env.REACT_APP_DMB_URL}/users/login/${store?.intRitasStoreID}/editoptions/${profile?.role}`;
          window.open(editOptionsUrl);
          break;
        default:
          window.open(lnk.link);
          break;
      }
    } else {
      navigate(`/${lnk.comp}`);
    }
  };

  // Okta app label (lowercase) that grants P&L Submission access
  const PL_OKTA_LABELS = ["p&l submission"];

  const canViewProfitLoss = () => {
    const roleAllowed = ["Super Admin", "Admin", "Franchisee", "Director(FC Lead)", "Franchise Consultant"].includes(profile?.role);
    const oktaAllowed = PL_OKTA_LABELS.some(label => oktaApps.includes(label));
    return roleAllowed && oktaAllowed;
  };

  // Okta app labels (lowercase) that grant RFC Library access
 const RFC_LIBRARY_OKTA_LABELS = ["rfc library", "rfc library - dst"];
 const havePermissionToView = (menu) => {
    const env = process.env?.REACT_APP_ENVIRONMENT

    // RFC Library is gated solely by Okta app assignment, bypassing DB-based permissions entirely.
    if (menu === "rfclibrary") {
      return RFC_LIBRARY_OKTA_LABELS.some(label => oktaApps.includes(label));
    }

    // P&L Submission is gated by role AND Okta app assignment (see canViewProfitLoss).
    if (menu === "ProfitLossTool") {
      return canViewProfitLoss();
    }

    // DB-based permission
    if (permissions?.[menu] === true) return true;

    // TRAIN env overrides
    if (env === "TRAIN" && menu === "LoyaltyPortal") return true;
    if (env === "TRAIN" && menu === "OnlineOrdering") return true;
    if (menu === "ProfitLossTool" && canViewProfitLoss()) return true;

    return false;
  };

  const handleChangeStore = (val) => {
    setStore(val);
    dispatch(storeSet(val));
  };
  const handleStoreClick = () => {
    setStore("");
    dispatch(storeSet(""));
  };

  if (!accessToken) {
    return (
      <>
        {" "}
        <div className="site-card-wrapper">
          <div className="main-dashboard-container">
            <DashboardLoader />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Dashboard
            </h1>
          </div>
        </header>
        <main>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={storeLoading || permissionLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="px-4 py-8 sm:px-0 dashboard-tour-selector">
              <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {options.map((option) => {
                  return havePermissionToView(option.text) ? (
                    <div
                      onClick={() => openSite(option)}
                      className="bg-white dark:bg-gray-800 rounded shadow px-4 py-3 flex items-center cursor-pointer "
                    >
                      <div className="p-2 bg-primary text-white rounded">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-click"
                          width={32}
                          height={32}
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <line x1={3} y1={12} x2={6} y2={12} />
                          <line x1={12} y1={3} x2={12} y2={6} />
                          <line x1="7.8" y1="7.8" x2="5.6" y2="5.6" />
                          <line x1="16.2" y1="7.8" x2="18.4" y2="5.6" />
                          <line x1="7.8" y1="16.2" x2="5.6" y2="18.4" />
                          <path d="M12 12l9 3l-4 2l-2 4l-3 -9" />
                        </svg>
                      </div>
                      <div className="ml-6">
                        <h3 className="mb-1 leading-5 text-gray-800 dark:text-gray-100 font-medium text-md">{`${option.name}`}</h3>
                      </div>
                    </div>
                  ) : (
                    ""
                  );
                })}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default AdminDashboard;
